import styled from '@emotion/styled';
import { Variables } from 'styles/variables/variables';
import { Colors } from 'styles/variables/colors';

const { assistant } = Variables;

export const Tip = styled.div<{ mobile: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${({ mobile }) => (mobile ? Colors.white : Colors.lightBlue)};
    padding: 8px 10px;
    box-sizing: border-box;
    border-radius: ${({ mobile }) => (mobile ? '8px' : '4px')};
    width: fit-content;
    border: ${({ mobile }) => (mobile ? '1px solid #f3f4f6ff' : '')};
    box-shadow: ${({ mobile }) => (mobile ? '0px 10px 20px -15px #171a1f' : '')};
`;
export const TipDesc = styled.span<{ mobile: boolean }>`
    font-family: ${assistant};
    color: ${({ mobile }) => (mobile ? Colors.salesNextBtn : Colors.gray)};
    font-size: 15px;
    line-height: 1;
    font-weight: 700;
    margin-left: 18px;
`;
